import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Bitacora/bitacora';
import BitacoraVer from './BitacoraVer';

const mstp = state => {
    return {...state.bitacora}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(BitacoraVer)
